/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ohat API
 * API群
 * OpenAPI spec version: 1.1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptInvitationDto,
  Account,
  CheckoutResponseDto,
  ConfirmPhotoDto,
  CreateAccountDto,
  CreateInvitationDto,
  CreateOhatScoreDto,
  CreateOrganizationDto,
  CreatePatientDto,
  CreateTagDto,
  FindPatientsResponseDto,
  HealthcheckResponseDto,
  HttpExceptionResponseDto,
  InvitationVerifyTokenParams,
  OhatScore,
  OhatScoreFindFirstAndLatestParams,
  Organization,
  Patient,
  PatientFindManyParams,
  PatientPhotoResponseDto,
  PatientScoreCountDto,
  PhotoResponseDto,
  PortalResponseDto,
  PresignPhotoDto,
  PresignPhotoResponseDto,
  RequestAdminStepUpResponseDto,
  SetPatientTagsDto,
  SubscriptionsMeResponseDto,
  SubscriptionsUsageResponseDto,
  TagDto,
  UpdateAccountDto,
  UpdateCareProtocolDto,
  UpdateMemberDto,
  UpdateOrganizationDto,
  UpdatePatientDto,
  UpdateTagDto,
  VerifyAdminStepUpDto,
  VerifyAdminStepUpResponseDto,
  WithdrawOrganizationResponseDto
} from '../models';

import { customInstance } from './axios-config';
import type { ErrorType , BodyType } from './axios-config';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary 新規Cognitoアカウントおよび初期データの作成
 */
export const accountCreate = (
    createAccountDto: BodyType<CreateAccountDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Account>(
      {url: `/accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAccountDto, signal
    },
      options);
    }
  


export const getAccountCreateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountCreate>>, TError,{data: BodyType<CreateAccountDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof accountCreate>>, TError,{data: BodyType<CreateAccountDto>}, TContext> => {

const mutationKey = ['accountCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountCreate>>, {data: BodyType<CreateAccountDto>}> = (props) => {
          const {data} = props ?? {};

          return  accountCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AccountCreateMutationResult = NonNullable<Awaited<ReturnType<typeof accountCreate>>>
    export type AccountCreateMutationBody = BodyType<CreateAccountDto>
    export type AccountCreateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary 新規Cognitoアカウントおよび初期データの作成
 */
export const useAccountCreate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountCreate>>, TError,{data: BodyType<CreateAccountDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountCreate>>,
        TError,
        {data: BodyType<CreateAccountDto>},
        TContext
      > => {

      const mutationOptions = getAccountCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary accountsの取得
 */
export const accountFindAll = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Account[]>(
      {url: `/accounts`, method: 'GET', signal
    },
      options);
    }
  



export const getAccountFindAllQueryKey = () => {
    return [
    `/accounts`
    ] as const;
    }

    
export const getAccountFindAllQueryOptions = <TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountFindAll>>> = ({ signal }) => accountFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof accountFindAll>>>
export type AccountFindAllQueryError = ErrorType<HttpExceptionResponseDto>


export function useAccountFindAll<TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountFindAll>>,
          TError,
          Awaited<ReturnType<typeof accountFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountFindAll<TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountFindAll>>,
          TError,
          Awaited<ReturnType<typeof accountFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountFindAll<TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary accountsの取得
 */

export function useAccountFindAll<TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountFindAllSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountFindAll>>> = ({ signal }) => accountFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountFindAllSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof accountFindAll>>>
export type AccountFindAllSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useAccountFindAllSuspense<TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountFindAllSuspense<TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountFindAllSuspense<TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary accountsの取得
 */

export function useAccountFindAllSuspense<TData = Awaited<ReturnType<typeof accountFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountFindAllSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary accountの取得
 */
export const accountFindOne = (
    sub: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Account>(
      {url: `/accounts/${sub}`, method: 'GET', signal
    },
      options);
    }
  



export const getAccountFindOneQueryKey = (sub?: string,) => {
    return [
    `/accounts/${sub}`
    ] as const;
    }

    
export const getAccountFindOneQueryOptions = <TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(sub: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountFindOneQueryKey(sub);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountFindOne>>> = ({ signal }) => accountFindOne(sub, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sub), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof accountFindOne>>>
export type AccountFindOneQueryError = ErrorType<HttpExceptionResponseDto>


export function useAccountFindOne<TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 sub: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountFindOne>>,
          TError,
          Awaited<ReturnType<typeof accountFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountFindOne<TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 sub: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountFindOne>>,
          TError,
          Awaited<ReturnType<typeof accountFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountFindOne<TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 sub: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary accountの取得
 */

export function useAccountFindOne<TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 sub: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountFindOneQueryOptions(sub,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountFindOneSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(sub: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAccountFindOneQueryKey(sub);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof accountFindOne>>> = ({ signal }) => accountFindOne(sub, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AccountFindOneSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof accountFindOne>>>
export type AccountFindOneSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useAccountFindOneSuspense<TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 sub: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountFindOneSuspense<TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 sub: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAccountFindOneSuspense<TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 sub: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary accountの取得
 */

export function useAccountFindOneSuspense<TData = Awaited<ReturnType<typeof accountFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 sub: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof accountFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAccountFindOneSuspenseQueryOptions(sub,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary accountの更新
 */
export const accountUpdate = (
    id: string,
    updateAccountDto: BodyType<UpdateAccountDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Account>(
      {url: `/accounts/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateAccountDto
    },
      options);
    }
  


export const getAccountUpdateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountUpdate>>, TError,{id: string;data: BodyType<UpdateAccountDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof accountUpdate>>, TError,{id: string;data: BodyType<UpdateAccountDto>}, TContext> => {

const mutationKey = ['accountUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountUpdate>>, {id: string;data: BodyType<UpdateAccountDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  accountUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AccountUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof accountUpdate>>>
    export type AccountUpdateMutationBody = BodyType<UpdateAccountDto>
    export type AccountUpdateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary accountの更新
 */
export const useAccountUpdate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountUpdate>>, TError,{id: string;data: BodyType<UpdateAccountDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountUpdate>>,
        TError,
        {id: string;data: BodyType<UpdateAccountDto>},
        TContext
      > => {

      const mutationOptions = getAccountUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary accountの最終アクティビティ時刻更新
 */
export const accountUpdateActivity = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Account>(
      {url: `/accounts/${id}/activity`, method: 'PATCH'
    },
      options);
    }
  


export const getAccountUpdateActivityMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountUpdateActivity>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof accountUpdateActivity>>, TError,{id: string}, TContext> => {

const mutationKey = ['accountUpdateActivity'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof accountUpdateActivity>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  accountUpdateActivity(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AccountUpdateActivityMutationResult = NonNullable<Awaited<ReturnType<typeof accountUpdateActivity>>>
    
    export type AccountUpdateActivityMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary accountの最終アクティビティ時刻更新
 */
export const useAccountUpdateActivity = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof accountUpdateActivity>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof accountUpdateActivity>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAccountUpdateActivityMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Stripe Checkout Sessionを作成する
 */
export const subscriptionCheckout = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CheckoutResponseDto>(
      {url: `/subscriptions/checkout`, method: 'POST', signal
    },
      options);
    }
  


export const getSubscriptionCheckoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscriptionCheckout>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof subscriptionCheckout>>, TError,void, TContext> => {

const mutationKey = ['subscriptionCheckout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscriptionCheckout>>, void> = () => {
          

          return  subscriptionCheckout(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubscriptionCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof subscriptionCheckout>>>
    
    export type SubscriptionCheckoutMutationError = ErrorType<unknown>

    /**
 * @summary Stripe Checkout Sessionを作成する
 */
export const useSubscriptionCheckout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscriptionCheckout>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof subscriptionCheckout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSubscriptionCheckoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Stripe Customer Portal Sessionを作成する
 */
export const subscriptionPortal = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PortalResponseDto>(
      {url: `/subscriptions/portal`, method: 'POST', signal
    },
      options);
    }
  


export const getSubscriptionPortalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscriptionPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof subscriptionPortal>>, TError,void, TContext> => {

const mutationKey = ['subscriptionPortal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof subscriptionPortal>>, void> = () => {
          

          return  subscriptionPortal(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubscriptionPortalMutationResult = NonNullable<Awaited<ReturnType<typeof subscriptionPortal>>>
    
    export type SubscriptionPortalMutationError = ErrorType<unknown>

    /**
 * @summary Stripe Customer Portal Sessionを作成する
 */
export const useSubscriptionPortal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof subscriptionPortal>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof subscriptionPortal>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getSubscriptionPortalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 現在のプラン情報を取得する
 */
export const subscriptionMe = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubscriptionsMeResponseDto>(
      {url: `/subscriptions/me`, method: 'GET', signal
    },
      options);
    }
  



export const getSubscriptionMeQueryKey = () => {
    return [
    `/subscriptions/me`
    ] as const;
    }

    
export const getSubscriptionMeQueryOptions = <TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscriptionMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscriptionMe>>> = ({ signal }) => subscriptionMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SubscriptionMeQueryResult = NonNullable<Awaited<ReturnType<typeof subscriptionMe>>>
export type SubscriptionMeQueryError = ErrorType<unknown>


export function useSubscriptionMe<TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscriptionMe>>,
          TError,
          Awaited<ReturnType<typeof subscriptionMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscriptionMe<TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscriptionMe>>,
          TError,
          Awaited<ReturnType<typeof subscriptionMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscriptionMe<TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 現在のプラン情報を取得する
 */

export function useSubscriptionMe<TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSubscriptionMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSubscriptionMeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscriptionMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscriptionMe>>> = ({ signal }) => subscriptionMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SubscriptionMeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof subscriptionMe>>>
export type SubscriptionMeSuspenseQueryError = ErrorType<unknown>


export function useSubscriptionMeSuspense<TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscriptionMeSuspense<TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscriptionMeSuspense<TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 現在のプラン情報を取得する
 */

export function useSubscriptionMeSuspense<TData = Awaited<ReturnType<typeof subscriptionMe>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSubscriptionMeSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary 現在の使用量と上限の一覧を取得する
 */
export const subscriptionUsage = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SubscriptionsUsageResponseDto>(
      {url: `/subscriptions/me/usage`, method: 'GET', signal
    },
      options);
    }
  



export const getSubscriptionUsageQueryKey = () => {
    return [
    `/subscriptions/me/usage`
    ] as const;
    }

    
export const getSubscriptionUsageQueryOptions = <TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscriptionUsageQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscriptionUsage>>> = ({ signal }) => subscriptionUsage(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SubscriptionUsageQueryResult = NonNullable<Awaited<ReturnType<typeof subscriptionUsage>>>
export type SubscriptionUsageQueryError = ErrorType<unknown>


export function useSubscriptionUsage<TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscriptionUsage>>,
          TError,
          Awaited<ReturnType<typeof subscriptionUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscriptionUsage<TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof subscriptionUsage>>,
          TError,
          Awaited<ReturnType<typeof subscriptionUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscriptionUsage<TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 現在の使用量と上限の一覧を取得する
 */

export function useSubscriptionUsage<TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSubscriptionUsageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSubscriptionUsageSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscriptionUsageQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscriptionUsage>>> = ({ signal }) => subscriptionUsage(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SubscriptionUsageSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof subscriptionUsage>>>
export type SubscriptionUsageSuspenseQueryError = ErrorType<unknown>


export function useSubscriptionUsageSuspense<TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscriptionUsageSuspense<TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSubscriptionUsageSuspense<TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 現在の使用量と上限の一覧を取得する
 */

export function useSubscriptionUsageSuspense<TData = Awaited<ReturnType<typeof subscriptionUsage>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof subscriptionUsage>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSubscriptionUsageSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary ヘルスチェック
 */
export const healthcheckGetPayment = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<HealthcheckResponseDto>(
      {url: `/`, method: 'GET', signal
    },
      options);
    }
  



export const getHealthcheckGetPaymentQueryKey = () => {
    return [
    `/`
    ] as const;
    }

    
export const getHealthcheckGetPaymentQueryOptions = <TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckGetPaymentQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthcheckGetPayment>>> = ({ signal }) => healthcheckGetPayment(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthcheckGetPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof healthcheckGetPayment>>>
export type HealthcheckGetPaymentQueryError = ErrorType<HttpExceptionResponseDto>


export function useHealthcheckGetPayment<TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheckGetPayment>>,
          TError,
          Awaited<ReturnType<typeof healthcheckGetPayment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheckGetPayment<TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheckGetPayment>>,
          TError,
          Awaited<ReturnType<typeof healthcheckGetPayment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheckGetPayment<TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ヘルスチェック
 */

export function useHealthcheckGetPayment<TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthcheckGetPaymentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getHealthcheckGetPaymentSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckGetPaymentQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthcheckGetPayment>>> = ({ signal }) => healthcheckGetPayment(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthcheckGetPaymentSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof healthcheckGetPayment>>>
export type HealthcheckGetPaymentSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useHealthcheckGetPaymentSuspense<TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheckGetPaymentSuspense<TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheckGetPaymentSuspense<TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ヘルスチェック
 */

export function useHealthcheckGetPaymentSuspense<TData = Awaited<ReturnType<typeof healthcheckGetPayment>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof healthcheckGetPayment>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthcheckGetPaymentSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * 作成したアカウントはその組織の owner として所属する（最初のユーザは必ず組織管理者になる）。既に組織に所属している場合は作成できない（409）。
 * @summary organizationの作成
 */
export const organizationCreate = (
    createOrganizationDto: BodyType<CreateOrganizationDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Organization>(
      {url: `/organizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOrganizationDto, signal
    },
      options);
    }
  


export const getOrganizationCreateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationCreate>>, TError,{data: BodyType<CreateOrganizationDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationCreate>>, TError,{data: BodyType<CreateOrganizationDto>}, TContext> => {

const mutationKey = ['organizationCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationCreate>>, {data: BodyType<CreateOrganizationDto>}> = (props) => {
          const {data} = props ?? {};

          return  organizationCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationCreate>>>
    export type OrganizationCreateMutationBody = BodyType<CreateOrganizationDto>
    export type OrganizationCreateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary organizationの作成
 */
export const useOrganizationCreate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationCreate>>, TError,{data: BodyType<CreateOrganizationDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationCreate>>,
        TError,
        {data: BodyType<CreateOrganizationDto>},
        TContext
      > => {

      const mutationOptions = getOrganizationCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary organizationsの取得
 */
export const organizationFindAll = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Organization[]>(
      {url: `/organizations`, method: 'GET', signal
    },
      options);
    }
  



export const getOrganizationFindAllQueryKey = () => {
    return [
    `/organizations`
    ] as const;
    }

    
export const getOrganizationFindAllQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindAll>>> = ({ signal }) => organizationFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindAll>>>
export type OrganizationFindAllQueryError = ErrorType<HttpExceptionResponseDto>


export function useOrganizationFindAll<TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindAll>>,
          TError,
          Awaited<ReturnType<typeof organizationFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAll<TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindAll>>,
          TError,
          Awaited<ReturnType<typeof organizationFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAll<TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary organizationsの取得
 */

export function useOrganizationFindAll<TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationFindAllSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindAll>>> = ({ signal }) => organizationFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindAllSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindAll>>>
export type OrganizationFindAllSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useOrganizationFindAllSuspense<TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllSuspense<TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllSuspense<TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary organizationsの取得
 */

export function useOrganizationFindAllSuspense<TData = Awaited<ReturnType<typeof organizationFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindAllSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary organizationの取得
 */
export const organizationFindOne = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Organization>(
      {url: `/organizations/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getOrganizationFindOneQueryKey = (id?: string,) => {
    return [
    `/organizations/${id}`
    ] as const;
    }

    
export const getOrganizationFindOneQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindOne>>> = ({ signal }) => organizationFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindOne>>>
export type OrganizationFindOneQueryError = ErrorType<HttpExceptionResponseDto>


export function useOrganizationFindOne<TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindOne>>,
          TError,
          Awaited<ReturnType<typeof organizationFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindOne<TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindOne>>,
          TError,
          Awaited<ReturnType<typeof organizationFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindOne<TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary organizationの取得
 */

export function useOrganizationFindOne<TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationFindOneSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindOne>>> = ({ signal }) => organizationFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindOneSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindOne>>>
export type OrganizationFindOneSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useOrganizationFindOneSuspense<TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindOneSuspense<TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindOneSuspense<TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary organizationの取得
 */

export function useOrganizationFindOneSuspense<TData = Awaited<ReturnType<typeof organizationFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindOneSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary organizationの更新
 */
export const organizationUpdate = (
    id: string,
    updateOrganizationDto: BodyType<UpdateOrganizationDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Organization>(
      {url: `/organizations/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationDto
    },
      options);
    }
  


export const getOrganizationUpdateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationUpdate>>, TError,{id: string;data: BodyType<UpdateOrganizationDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationUpdate>>, TError,{id: string;data: BodyType<UpdateOrganizationDto>}, TContext> => {

const mutationKey = ['organizationUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationUpdate>>, {id: string;data: BodyType<UpdateOrganizationDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  organizationUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof organizationUpdate>>>
    export type OrganizationUpdateMutationBody = BodyType<UpdateOrganizationDto>
    export type OrganizationUpdateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary organizationの更新
 */
export const useOrganizationUpdate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationUpdate>>, TError,{id: string;data: BodyType<UpdateOrganizationDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationUpdate>>,
        TError,
        {id: string;data: BodyType<UpdateOrganizationDto>},
        TContext
      > => {

      const mutationOptions = getOrganizationUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary organizationの削除
 */
export const organizationRemove = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Organization>(
      {url: `/organizations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getOrganizationRemoveMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['organizationRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  organizationRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof organizationRemove>>>
    
    export type OrganizationRemoveMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary organizationの削除
 */
export const useOrganizationRemove = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getOrganizationRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary patientsの取得
 */
export const organizationFindAllPatients = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Organization>(
      {url: `/organizations/${id}/patients`, method: 'GET', signal
    },
      options);
    }
  



export const getOrganizationFindAllPatientsQueryKey = (id?: string,) => {
    return [
    `/organizations/${id}/patients`
    ] as const;
    }

    
export const getOrganizationFindAllPatientsQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindAllPatientsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindAllPatients>>> = ({ signal }) => organizationFindAllPatients(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindAllPatientsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindAllPatients>>>
export type OrganizationFindAllPatientsQueryError = ErrorType<HttpExceptionResponseDto>


export function useOrganizationFindAllPatients<TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindAllPatients>>,
          TError,
          Awaited<ReturnType<typeof organizationFindAllPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllPatients<TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindAllPatients>>,
          TError,
          Awaited<ReturnType<typeof organizationFindAllPatients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllPatients<TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary patientsの取得
 */

export function useOrganizationFindAllPatients<TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindAllPatientsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationFindAllPatientsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindAllPatientsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindAllPatients>>> = ({ signal }) => organizationFindAllPatients(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindAllPatientsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindAllPatients>>>
export type OrganizationFindAllPatientsSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useOrganizationFindAllPatientsSuspense<TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllPatientsSuspense<TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllPatientsSuspense<TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary patientsの取得
 */

export function useOrganizationFindAllPatientsSuspense<TData = Awaited<ReturnType<typeof organizationFindAllPatients>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllPatients>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindAllPatientsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary accountsの取得
 */
export const organizationFindAllAccounts = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Organization>(
      {url: `/organizations/${id}/accounts`, method: 'GET', signal
    },
      options);
    }
  



export const getOrganizationFindAllAccountsQueryKey = (id?: string,) => {
    return [
    `/organizations/${id}/accounts`
    ] as const;
    }

    
export const getOrganizationFindAllAccountsQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindAllAccountsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindAllAccounts>>> = ({ signal }) => organizationFindAllAccounts(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindAllAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindAllAccounts>>>
export type OrganizationFindAllAccountsQueryError = ErrorType<HttpExceptionResponseDto>


export function useOrganizationFindAllAccounts<TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindAllAccounts>>,
          TError,
          Awaited<ReturnType<typeof organizationFindAllAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllAccounts<TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindAllAccounts>>,
          TError,
          Awaited<ReturnType<typeof organizationFindAllAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllAccounts<TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary accountsの取得
 */

export function useOrganizationFindAllAccounts<TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindAllAccountsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationFindAllAccountsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindAllAccountsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindAllAccounts>>> = ({ signal }) => organizationFindAllAccounts(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindAllAccountsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindAllAccounts>>>
export type OrganizationFindAllAccountsSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useOrganizationFindAllAccountsSuspense<TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllAccountsSuspense<TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindAllAccountsSuspense<TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary accountsの取得
 */

export function useOrganizationFindAllAccountsSuspense<TData = Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindAllAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindAllAccountsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * owner のみ実行可能。継続課金が有効な間は退会できない（409）。組織を退会状態にし、配下アカウントのサインインを停止する。この操作は取り消せない。
 * @summary 組織の退会（サービス退会）申請
 */
export const organizationWithdraw = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WithdrawOrganizationResponseDto>(
      {url: `/organizations/${id}/withdraw`, method: 'POST', signal
    },
      options);
    }
  


export const getOrganizationWithdrawMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationWithdraw>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationWithdraw>>, TError,{id: string}, TContext> => {

const mutationKey = ['organizationWithdraw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationWithdraw>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  organizationWithdraw(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationWithdrawMutationResult = NonNullable<Awaited<ReturnType<typeof organizationWithdraw>>>
    
    export type OrganizationWithdrawMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary 組織の退会（サービス退会）申請
 */
export const useOrganizationWithdraw = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationWithdraw>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationWithdraw>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getOrganizationWithdrawMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 所属メンバーと招待中リスト一覧
 */
export const organizationFindMembers = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/organizations/${id}/members`, method: 'GET', signal
    },
      options);
    }
  



export const getOrganizationFindMembersQueryKey = (id?: string,) => {
    return [
    `/organizations/${id}/members`
    ] as const;
    }

    
export const getOrganizationFindMembersQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindMembersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindMembers>>> = ({ signal }) => organizationFindMembers(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindMembersQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindMembers>>>
export type OrganizationFindMembersQueryError = ErrorType<unknown>


export function useOrganizationFindMembers<TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindMembers>>,
          TError,
          Awaited<ReturnType<typeof organizationFindMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindMembers<TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organizationFindMembers>>,
          TError,
          Awaited<ReturnType<typeof organizationFindMembers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindMembers<TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 所属メンバーと招待中リスト一覧
 */

export function useOrganizationFindMembers<TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindMembersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationFindMembersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationFindMembersQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationFindMembers>>> = ({ signal }) => organizationFindMembers(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OrganizationFindMembersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof organizationFindMembers>>>
export type OrganizationFindMembersSuspenseQueryError = ErrorType<unknown>


export function useOrganizationFindMembersSuspense<TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindMembersSuspense<TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOrganizationFindMembersSuspense<TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 所属メンバーと招待中リスト一覧
 */

export function useOrganizationFindMembersSuspense<TData = Awaited<ReturnType<typeof organizationFindMembers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof organizationFindMembers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOrganizationFindMembersSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary メンバーの無効化/有効化、ロール変更
 */
export const organizationUpdateMember = (
    id: string,
    accountId: string,
    updateMemberDto: BodyType<UpdateMemberDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/organizations/${id}/members/${accountId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateMemberDto
    },
      options);
    }
  


export const getOrganizationUpdateMemberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationUpdateMember>>, TError,{id: string;accountId: string;data: BodyType<UpdateMemberDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationUpdateMember>>, TError,{id: string;accountId: string;data: BodyType<UpdateMemberDto>}, TContext> => {

const mutationKey = ['organizationUpdateMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationUpdateMember>>, {id: string;accountId: string;data: BodyType<UpdateMemberDto>}> = (props) => {
          const {id,accountId,data} = props ?? {};

          return  organizationUpdateMember(id,accountId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationUpdateMemberMutationResult = NonNullable<Awaited<ReturnType<typeof organizationUpdateMember>>>
    export type OrganizationUpdateMemberMutationBody = BodyType<UpdateMemberDto>
    export type OrganizationUpdateMemberMutationError = ErrorType<unknown>

    /**
 * @summary メンバーの無効化/有効化、ロール変更
 */
export const useOrganizationUpdateMember = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationUpdateMember>>, TError,{id: string;accountId: string;data: BodyType<UpdateMemberDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationUpdateMember>>,
        TError,
        {id: string;accountId: string;data: BodyType<UpdateMemberDto>},
        TContext
      > => {

      const mutationOptions = getOrganizationUpdateMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary メンバーを組織から除外
 */
export const organizationRemoveMember = (
    id: string,
    accountId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/organizations/${id}/members/${accountId}`, method: 'DELETE'
    },
      options);
    }
  


export const getOrganizationRemoveMemberMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationRemoveMember>>, TError,{id: string;accountId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof organizationRemoveMember>>, TError,{id: string;accountId: string}, TContext> => {

const mutationKey = ['organizationRemoveMember'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof organizationRemoveMember>>, {id: string;accountId: string}> = (props) => {
          const {id,accountId} = props ?? {};

          return  organizationRemoveMember(id,accountId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationRemoveMemberMutationResult = NonNullable<Awaited<ReturnType<typeof organizationRemoveMember>>>
    
    export type OrganizationRemoveMemberMutationError = ErrorType<unknown>

    /**
 * @summary メンバーを組織から除外
 */
export const useOrganizationRemoveMember = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof organizationRemoveMember>>, TError,{id: string;accountId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof organizationRemoveMember>>,
        TError,
        {id: string;accountId: string},
        TContext
      > => {

      const mutationOptions = getOrganizationRemoveMemberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary patientの作成
 */
export const patientCreate = (
    createPatientDto: BodyType<CreatePatientDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Patient>(
      {url: `/patients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPatientDto, signal
    },
      options);
    }
  


export const getPatientCreateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreate>>, TError,{data: BodyType<CreatePatientDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientCreate>>, TError,{data: BodyType<CreatePatientDto>}, TContext> => {

const mutationKey = ['patientCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientCreate>>, {data: BodyType<CreatePatientDto>}> = (props) => {
          const {data} = props ?? {};

          return  patientCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientCreateMutationResult = NonNullable<Awaited<ReturnType<typeof patientCreate>>>
    export type PatientCreateMutationBody = BodyType<CreatePatientDto>
    export type PatientCreateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary patientの作成
 */
export const usePatientCreate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientCreate>>, TError,{data: BodyType<CreatePatientDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientCreate>>,
        TError,
        {data: BodyType<CreatePatientDto>},
        TContext
      > => {

      const mutationOptions = getPatientCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 患者一覧の取得（ページング・検索対応）
 */
export const patientFindMany = (
    params?: PatientFindManyParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FindPatientsResponseDto>(
      {url: `/patients`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getPatientFindManyQueryKey = (params?: PatientFindManyParams,) => {
    return [
    `/patients`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getPatientFindManyQueryOptions = <TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(params?: PatientFindManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientFindManyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientFindMany>>> = ({ signal }) => patientFindMany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientFindManyQueryResult = NonNullable<Awaited<ReturnType<typeof patientFindMany>>>
export type PatientFindManyQueryError = ErrorType<HttpExceptionResponseDto>


export function usePatientFindMany<TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(
 params: undefined |  PatientFindManyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientFindMany>>,
          TError,
          Awaited<ReturnType<typeof patientFindMany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindMany<TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(
 params?: PatientFindManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientFindMany>>,
          TError,
          Awaited<ReturnType<typeof patientFindMany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindMany<TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(
 params?: PatientFindManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者一覧の取得（ページング・検索対応）
 */

export function usePatientFindMany<TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(
 params?: PatientFindManyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientFindManyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientFindManySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(params?: PatientFindManyParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientFindManyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientFindMany>>> = ({ signal }) => patientFindMany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientFindManySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof patientFindMany>>>
export type PatientFindManySuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function usePatientFindManySuspense<TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(
 params: undefined |  PatientFindManyParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindManySuspense<TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(
 params?: PatientFindManyParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindManySuspense<TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(
 params?: PatientFindManyParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者一覧の取得（ページング・検索対応）
 */

export function usePatientFindManySuspense<TData = Awaited<ReturnType<typeof patientFindMany>>, TError = ErrorType<HttpExceptionResponseDto>>(
 params?: PatientFindManyParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindMany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientFindManySuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary patientの取得
 */
export const patientFindOne = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Patient>(
      {url: `/patients/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getPatientFindOneQueryKey = (id?: string,) => {
    return [
    `/patients/${id}`
    ] as const;
    }

    
export const getPatientFindOneQueryOptions = <TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientFindOne>>> = ({ signal }) => patientFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof patientFindOne>>>
export type PatientFindOneQueryError = ErrorType<HttpExceptionResponseDto>


export function usePatientFindOne<TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientFindOne>>,
          TError,
          Awaited<ReturnType<typeof patientFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindOne<TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientFindOne>>,
          TError,
          Awaited<ReturnType<typeof patientFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindOne<TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary patientの取得
 */

export function usePatientFindOne<TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientFindOneSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientFindOne>>> = ({ signal }) => patientFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientFindOneSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof patientFindOne>>>
export type PatientFindOneSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function usePatientFindOneSuspense<TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindOneSuspense<TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindOneSuspense<TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary patientの取得
 */

export function usePatientFindOneSuspense<TData = Awaited<ReturnType<typeof patientFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientFindOneSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary patientの更新
 */
export const patientUpdate = (
    id: string,
    updatePatientDto: BodyType<UpdatePatientDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Patient>(
      {url: `/patients/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePatientDto
    },
      options);
    }
  


export const getPatientUpdateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdate>>, TError,{id: string;data: BodyType<UpdatePatientDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientUpdate>>, TError,{id: string;data: BodyType<UpdatePatientDto>}, TContext> => {

const mutationKey = ['patientUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientUpdate>>, {id: string;data: BodyType<UpdatePatientDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  patientUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof patientUpdate>>>
    export type PatientUpdateMutationBody = BodyType<UpdatePatientDto>
    export type PatientUpdateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary patientの更新
 */
export const usePatientUpdate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUpdate>>, TError,{id: string;data: BodyType<UpdatePatientDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientUpdate>>,
        TError,
        {id: string;data: BodyType<UpdatePatientDto>},
        TContext
      > => {

      const mutationOptions = getPatientUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary patientの削除
 */
export const patientRemove = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Patient>(
      {url: `/patients/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getPatientRemoveMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['patientRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patientRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof patientRemove>>>
    
    export type PatientRemoveMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary patientの削除
 */
export const usePatientRemove = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatientRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 年で絞らず当該患者の評価を全件返す。患者一覧APIは評価日しか返さないため、CSV出力などスコア本体が必要な用途で使う。
 * @summary patientと全ohat-scoresの取得
 */
export const patientFindAllOhatScores = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Patient>(
      {url: `/patients/${id}/ohat-scores`, method: 'GET', signal
    },
      options);
    }
  



export const getPatientFindAllOhatScoresQueryKey = (id?: string,) => {
    return [
    `/patients/${id}/ohat-scores`
    ] as const;
    }

    
export const getPatientFindAllOhatScoresQueryOptions = <TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientFindAllOhatScoresQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientFindAllOhatScores>>> = ({ signal }) => patientFindAllOhatScores(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientFindAllOhatScoresQueryResult = NonNullable<Awaited<ReturnType<typeof patientFindAllOhatScores>>>
export type PatientFindAllOhatScoresQueryError = ErrorType<HttpExceptionResponseDto>


export function usePatientFindAllOhatScores<TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientFindAllOhatScores>>,
          TError,
          Awaited<ReturnType<typeof patientFindAllOhatScores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindAllOhatScores<TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientFindAllOhatScores>>,
          TError,
          Awaited<ReturnType<typeof patientFindAllOhatScores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindAllOhatScores<TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary patientと全ohat-scoresの取得
 */

export function usePatientFindAllOhatScores<TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientFindAllOhatScoresQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientFindAllOhatScoresSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientFindAllOhatScoresQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientFindAllOhatScores>>> = ({ signal }) => patientFindAllOhatScores(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientFindAllOhatScoresSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof patientFindAllOhatScores>>>
export type PatientFindAllOhatScoresSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function usePatientFindAllOhatScoresSuspense<TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindAllOhatScoresSuspense<TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindAllOhatScoresSuspense<TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary patientと全ohat-scoresの取得
 */

export function usePatientFindAllOhatScoresSuspense<TData = Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindAllOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientFindAllOhatScoresSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary patientとohat-scoresの取得
 */
export const patientFindOhatScores = (
    id: string,
    yyyy: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PatientScoreCountDto>(
      {url: `/patients/${id}/ohat-scores/${yyyy}`, method: 'GET', signal
    },
      options);
    }
  



export const getPatientFindOhatScoresQueryKey = (id?: string,
    yyyy?: string,) => {
    return [
    `/patients/${id}/ohat-scores/${yyyy}`
    ] as const;
    }

    
export const getPatientFindOhatScoresQueryOptions = <TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string,
    yyyy: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientFindOhatScoresQueryKey(id,yyyy);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientFindOhatScores>>> = ({ signal }) => patientFindOhatScores(id,yyyy, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && yyyy), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientFindOhatScoresQueryResult = NonNullable<Awaited<ReturnType<typeof patientFindOhatScores>>>
export type PatientFindOhatScoresQueryError = ErrorType<HttpExceptionResponseDto>


export function usePatientFindOhatScores<TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string,
    yyyy: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientFindOhatScores>>,
          TError,
          Awaited<ReturnType<typeof patientFindOhatScores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindOhatScores<TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string,
    yyyy: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof patientFindOhatScores>>,
          TError,
          Awaited<ReturnType<typeof patientFindOhatScores>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindOhatScores<TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string,
    yyyy: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary patientとohat-scoresの取得
 */

export function usePatientFindOhatScores<TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string,
    yyyy: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientFindOhatScoresQueryOptions(id,yyyy,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPatientFindOhatScoresSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string,
    yyyy: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPatientFindOhatScoresQueryKey(id,yyyy);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof patientFindOhatScores>>> = ({ signal }) => patientFindOhatScores(id,yyyy, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PatientFindOhatScoresSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof patientFindOhatScores>>>
export type PatientFindOhatScoresSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function usePatientFindOhatScoresSuspense<TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string,
    yyyy: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindOhatScoresSuspense<TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string,
    yyyy: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePatientFindOhatScoresSuspense<TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string,
    yyyy: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary patientとohat-scoresの取得
 */

export function usePatientFindOhatScoresSuspense<TData = Awaited<ReturnType<typeof patientFindOhatScores>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string,
    yyyy: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof patientFindOhatScores>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatientFindOhatScoresSuspenseQueryOptions(id,yyyy,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary patientのアーカイブ
 */
export const patientArchive = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Patient>(
      {url: `/patients/${id}/archive`, method: 'PATCH'
    },
      options);
    }
  


export const getPatientArchiveMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientArchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientArchive>>, TError,{id: string}, TContext> => {

const mutationKey = ['patientArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientArchive>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patientArchive(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof patientArchive>>>
    
    export type PatientArchiveMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary patientのアーカイブ
 */
export const usePatientArchive = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientArchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientArchive>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatientArchiveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary patientのアーカイブ解除
 */
export const patientUnarchive = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Patient>(
      {url: `/patients/${id}/unarchive`, method: 'PATCH'
    },
      options);
    }
  


export const getPatientUnarchiveMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUnarchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patientUnarchive>>, TError,{id: string}, TContext> => {

const mutationKey = ['patientUnarchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patientUnarchive>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  patientUnarchive(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatientUnarchiveMutationResult = NonNullable<Awaited<ReturnType<typeof patientUnarchive>>>
    
    export type PatientUnarchiveMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary patientのアーカイブ解除
 */
export const usePatientUnarchive = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patientUnarchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patientUnarchive>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPatientUnarchiveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary ohatScoreの作成
 */
export const ohatScoreCreate = (
    createOhatScoreDto: BodyType<CreateOhatScoreDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OhatScore>(
      {url: `/ohat-scores`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createOhatScoreDto, signal
    },
      options);
    }
  


export const getOhatScoreCreateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ohatScoreCreate>>, TError,{data: BodyType<CreateOhatScoreDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ohatScoreCreate>>, TError,{data: BodyType<CreateOhatScoreDto>}, TContext> => {

const mutationKey = ['ohatScoreCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ohatScoreCreate>>, {data: BodyType<CreateOhatScoreDto>}> = (props) => {
          const {data} = props ?? {};

          return  ohatScoreCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OhatScoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof ohatScoreCreate>>>
    export type OhatScoreCreateMutationBody = BodyType<CreateOhatScoreDto>
    export type OhatScoreCreateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary ohatScoreの作成
 */
export const useOhatScoreCreate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ohatScoreCreate>>, TError,{data: BodyType<CreateOhatScoreDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ohatScoreCreate>>,
        TError,
        {data: BodyType<CreateOhatScoreDto>},
        TContext
      > => {

      const mutationOptions = getOhatScoreCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary ohatScoreの取得
 */
export const ohatScoreFindOne = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OhatScore>(
      {url: `/ohat-scores/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getOhatScoreFindOneQueryKey = (id?: string,) => {
    return [
    `/ohat-scores/${id}`
    ] as const;
    }

    
export const getOhatScoreFindOneQueryOptions = <TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOhatScoreFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ohatScoreFindOne>>> = ({ signal }) => ohatScoreFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OhatScoreFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof ohatScoreFindOne>>>
export type OhatScoreFindOneQueryError = ErrorType<HttpExceptionResponseDto>


export function useOhatScoreFindOne<TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ohatScoreFindOne>>,
          TError,
          Awaited<ReturnType<typeof ohatScoreFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOhatScoreFindOne<TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ohatScoreFindOne>>,
          TError,
          Awaited<ReturnType<typeof ohatScoreFindOne>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOhatScoreFindOne<TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ohatScoreの取得
 */

export function useOhatScoreFindOne<TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOhatScoreFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOhatScoreFindOneSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOhatScoreFindOneQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ohatScoreFindOne>>> = ({ signal }) => ohatScoreFindOne(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OhatScoreFindOneSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ohatScoreFindOne>>>
export type OhatScoreFindOneSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useOhatScoreFindOneSuspense<TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOhatScoreFindOneSuspense<TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOhatScoreFindOneSuspense<TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary ohatScoreの取得
 */

export function useOhatScoreFindOneSuspense<TData = Awaited<ReturnType<typeof ohatScoreFindOne>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindOne>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOhatScoreFindOneSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary ohatScoreの削除
 */
export const ohatScoreRemove = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<OhatScore>(
      {url: `/ohat-scores/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getOhatScoreRemoveMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ohatScoreRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof ohatScoreRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['ohatScoreRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ohatScoreRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  ohatScoreRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OhatScoreRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof ohatScoreRemove>>>
    
    export type OhatScoreRemoveMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary ohatScoreの削除
 */
export const useOhatScoreRemove = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ohatScoreRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ohatScoreRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getOhatScoreRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 初回のohatScoreの取得
 */
export const ohatScoreFindFirstAndLatest = (
    patientId: string,
    params: OhatScoreFindFirstAndLatestParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OhatScore[]>(
      {url: `/ohat-scores/${patientId}/first-and-latest`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getOhatScoreFindFirstAndLatestQueryKey = (patientId?: string,
    params?: OhatScoreFindFirstAndLatestParams,) => {
    return [
    `/ohat-scores/${patientId}/first-and-latest`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getOhatScoreFindFirstAndLatestQueryOptions = <TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOhatScoreFindFirstAndLatestQueryKey(patientId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>> = ({ signal }) => ohatScoreFindFirstAndLatest(patientId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(patientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OhatScoreFindFirstAndLatestQueryResult = NonNullable<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>>
export type OhatScoreFindFirstAndLatestQueryError = ErrorType<HttpExceptionResponseDto>


export function useOhatScoreFindFirstAndLatest<TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(
 patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>,
          TError,
          Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOhatScoreFindFirstAndLatest<TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(
 patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>,
          TError,
          Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOhatScoreFindFirstAndLatest<TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(
 patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 初回のohatScoreの取得
 */

export function useOhatScoreFindFirstAndLatest<TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(
 patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOhatScoreFindFirstAndLatestQueryOptions(patientId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOhatScoreFindFirstAndLatestSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOhatScoreFindFirstAndLatestQueryKey(patientId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>> = ({ signal }) => ohatScoreFindFirstAndLatest(patientId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type OhatScoreFindFirstAndLatestSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>>
export type OhatScoreFindFirstAndLatestSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useOhatScoreFindFirstAndLatestSuspense<TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(
 patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOhatScoreFindFirstAndLatestSuspense<TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(
 patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useOhatScoreFindFirstAndLatestSuspense<TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(
 patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 初回のohatScoreの取得
 */

export function useOhatScoreFindFirstAndLatestSuspense<TData = Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError = ErrorType<HttpExceptionResponseDto>>(
 patientId: string,
    params: OhatScoreFindFirstAndLatestParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof ohatScoreFindFirstAndLatest>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOhatScoreFindFirstAndLatestSuspenseQueryOptions(patientId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary メンバー招待の作成（トークン発行＆メール送信）
 */
export const invitationCreate = (
    createInvitationDto: BodyType<CreateInvitationDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/invitations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createInvitationDto, signal
    },
      options);
    }
  


export const getInvitationCreateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationCreate>>, TError,{data: BodyType<CreateInvitationDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof invitationCreate>>, TError,{data: BodyType<CreateInvitationDto>}, TContext> => {

const mutationKey = ['invitationCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitationCreate>>, {data: BodyType<CreateInvitationDto>}> = (props) => {
          const {data} = props ?? {};

          return  invitationCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvitationCreateMutationResult = NonNullable<Awaited<ReturnType<typeof invitationCreate>>>
    export type InvitationCreateMutationBody = BodyType<CreateInvitationDto>
    export type InvitationCreateMutationError = ErrorType<unknown>

    /**
 * @summary メンバー招待の作成（トークン発行＆メール送信）
 */
export const useInvitationCreate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationCreate>>, TError,{data: BodyType<CreateInvitationDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invitationCreate>>,
        TError,
        {data: BodyType<CreateInvitationDto>},
        TContext
      > => {

      const mutationOptions = getInvitationCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 招待トークンの有効性確認（認証不要）
 */
export const invitationVerifyToken = (
    params: InvitationVerifyTokenParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/invitations/verify`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getInvitationVerifyTokenQueryKey = (params?: InvitationVerifyTokenParams,) => {
    return [
    `/invitations/verify`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getInvitationVerifyTokenQueryOptions = <TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(params: InvitationVerifyTokenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationVerifyTokenQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationVerifyToken>>> = ({ signal }) => invitationVerifyToken(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationVerifyTokenQueryResult = NonNullable<Awaited<ReturnType<typeof invitationVerifyToken>>>
export type InvitationVerifyTokenQueryError = ErrorType<unknown>


export function useInvitationVerifyToken<TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(
 params: InvitationVerifyTokenParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationVerifyToken>>,
          TError,
          Awaited<ReturnType<typeof invitationVerifyToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationVerifyToken<TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(
 params: InvitationVerifyTokenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationVerifyToken>>,
          TError,
          Awaited<ReturnType<typeof invitationVerifyToken>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationVerifyToken<TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(
 params: InvitationVerifyTokenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 招待トークンの有効性確認（認証不要）
 */

export function useInvitationVerifyToken<TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(
 params: InvitationVerifyTokenParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationVerifyTokenQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInvitationVerifyTokenSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(params: InvitationVerifyTokenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationVerifyTokenQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationVerifyToken>>> = ({ signal }) => invitationVerifyToken(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationVerifyTokenSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof invitationVerifyToken>>>
export type InvitationVerifyTokenSuspenseQueryError = ErrorType<unknown>


export function useInvitationVerifyTokenSuspense<TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(
 params: InvitationVerifyTokenParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationVerifyTokenSuspense<TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(
 params: InvitationVerifyTokenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationVerifyTokenSuspense<TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(
 params: InvitationVerifyTokenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 招待トークンの有効性確認（認証不要）
 */

export function useInvitationVerifyTokenSuspense<TData = Awaited<ReturnType<typeof invitationVerifyToken>>, TError = ErrorType<unknown>>(
 params: InvitationVerifyTokenParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof invitationVerifyToken>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationVerifyTokenSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary 招待の受諾（アカウント紐付け）
 */
export const invitationAccept = (
    acceptInvitationDto: BodyType<AcceptInvitationDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/invitations/accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptInvitationDto, signal
    },
      options);
    }
  


export const getInvitationAcceptMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationAccept>>, TError,{data: BodyType<AcceptInvitationDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof invitationAccept>>, TError,{data: BodyType<AcceptInvitationDto>}, TContext> => {

const mutationKey = ['invitationAccept'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitationAccept>>, {data: BodyType<AcceptInvitationDto>}> = (props) => {
          const {data} = props ?? {};

          return  invitationAccept(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvitationAcceptMutationResult = NonNullable<Awaited<ReturnType<typeof invitationAccept>>>
    export type InvitationAcceptMutationBody = BodyType<AcceptInvitationDto>
    export type InvitationAcceptMutationError = ErrorType<unknown>

    /**
 * @summary 招待の受諾（アカウント紐付け）
 */
export const useInvitationAccept = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationAccept>>, TError,{data: BodyType<AcceptInvitationDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invitationAccept>>,
        TError,
        {data: BodyType<AcceptInvitationDto>},
        TContext
      > => {

      const mutationOptions = getInvitationAcceptMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 招待の取り消し
 */
export const invitationRevoke = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/invitations/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getInvitationRevokeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationRevoke>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof invitationRevoke>>, TError,{id: string}, TContext> => {

const mutationKey = ['invitationRevoke'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitationRevoke>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  invitationRevoke(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvitationRevokeMutationResult = NonNullable<Awaited<ReturnType<typeof invitationRevoke>>>
    
    export type InvitationRevokeMutationError = ErrorType<unknown>

    /**
 * @summary 招待の取り消し
 */
export const useInvitationRevoke = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationRevoke>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invitationRevoke>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getInvitationRevokeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Stripe Webhookを受信する
 */
export const stripeWebhookHandleStripeWebhook = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/webhooks/stripe`, method: 'POST', signal
    },
      options);
    }
  


export const getStripeWebhookHandleStripeWebhookMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeWebhookHandleStripeWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof stripeWebhookHandleStripeWebhook>>, TError,void, TContext> => {

const mutationKey = ['stripeWebhookHandleStripeWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stripeWebhookHandleStripeWebhook>>, void> = () => {
          

          return  stripeWebhookHandleStripeWebhook(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type StripeWebhookHandleStripeWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof stripeWebhookHandleStripeWebhook>>>
    
    export type StripeWebhookHandleStripeWebhookMutationError = ErrorType<unknown>

    /**
 * @summary Stripe Webhookを受信する
 */
export const useStripeWebhookHandleStripeWebhook = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stripeWebhookHandleStripeWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stripeWebhookHandleStripeWebhook>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getStripeWebhookHandleStripeWebhookMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 組織のタグ一覧（患者数付き）
 */
export const tagFindAll = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TagDto[]>(
      {url: `/tags`, method: 'GET', signal
    },
      options);
    }
  



export const getTagFindAllQueryKey = () => {
    return [
    `/tags`
    ] as const;
    }

    
export const getTagFindAllQueryOptions = <TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagFindAll>>> = ({ signal }) => tagFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof tagFindAll>>>
export type TagFindAllQueryError = ErrorType<HttpExceptionResponseDto>


export function useTagFindAll<TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagFindAll>>,
          TError,
          Awaited<ReturnType<typeof tagFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagFindAll<TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagFindAll>>,
          TError,
          Awaited<ReturnType<typeof tagFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagFindAll<TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 組織のタグ一覧（患者数付き）
 */

export function useTagFindAll<TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTagFindAllSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagFindAll>>> = ({ signal }) => tagFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagFindAllSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tagFindAll>>>
export type TagFindAllSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useTagFindAllSuspense<TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagFindAllSuspense<TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagFindAllSuspense<TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 組織のタグ一覧（患者数付き）
 */

export function useTagFindAllSuspense<TData = Awaited<ReturnType<typeof tagFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagFindAllSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary タグの作成（ライトプラン限定）
 */
export const tagCreate = (
    createTagDto: BodyType<CreateTagDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/tags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTagDto, signal
    },
      options);
    }
  


export const getTagCreateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagCreate>>, TError,{data: BodyType<CreateTagDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tagCreate>>, TError,{data: BodyType<CreateTagDto>}, TContext> => {

const mutationKey = ['tagCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagCreate>>, {data: BodyType<CreateTagDto>}> = (props) => {
          const {data} = props ?? {};

          return  tagCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TagCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tagCreate>>>
    export type TagCreateMutationBody = BodyType<CreateTagDto>
    export type TagCreateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary タグの作成（ライトプラン限定）
 */
export const useTagCreate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagCreate>>, TError,{data: BodyType<CreateTagDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagCreate>>,
        TError,
        {data: BodyType<CreateTagDto>},
        TContext
      > => {

      const mutationOptions = getTagCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary タグ名の変更（ライトプラン限定）
 */
export const tagUpdate = (
    id: string,
    updateTagDto: BodyType<UpdateTagDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<unknown>(
      {url: `/tags/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTagDto
    },
      options);
    }
  


export const getTagUpdateMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagUpdate>>, TError,{id: string;data: BodyType<UpdateTagDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tagUpdate>>, TError,{id: string;data: BodyType<UpdateTagDto>}, TContext> => {

const mutationKey = ['tagUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagUpdate>>, {id: string;data: BodyType<UpdateTagDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  tagUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TagUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof tagUpdate>>>
    export type TagUpdateMutationBody = BodyType<UpdateTagDto>
    export type TagUpdateMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary タグ名の変更（ライトプラン限定）
 */
export const useTagUpdate = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagUpdate>>, TError,{id: string;data: BodyType<UpdateTagDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagUpdate>>,
        TError,
        {id: string;data: BodyType<UpdateTagDto>},
        TContext
      > => {

      const mutationOptions = getTagUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary タグの削除（ライトプラン限定）
 */
export const tagRemove = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<unknown>(
      {url: `/tags/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getTagRemoveMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tagRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['tagRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tagRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TagRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof tagRemove>>>
    
    export type TagRemoveMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary タグの削除（ライトプラン限定）
 */
export const useTagRemove = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTagRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 患者へのタグ付け替え（全置換・ライトプラン限定）
 */
export const tagSetPatientTags = (
    id: string,
    setPatientTagsDto: BodyType<SetPatientTagsDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<unknown>(
      {url: `/patients/${id}/tags`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setPatientTagsDto
    },
      options);
    }
  


export const getTagSetPatientTagsMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagSetPatientTags>>, TError,{id: string;data: BodyType<SetPatientTagsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tagSetPatientTags>>, TError,{id: string;data: BodyType<SetPatientTagsDto>}, TContext> => {

const mutationKey = ['tagSetPatientTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagSetPatientTags>>, {id: string;data: BodyType<SetPatientTagsDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  tagSetPatientTags(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TagSetPatientTagsMutationResult = NonNullable<Awaited<ReturnType<typeof tagSetPatientTags>>>
    export type TagSetPatientTagsMutationBody = BodyType<SetPatientTagsDto>
    export type TagSetPatientTagsMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary 患者へのタグ付け替え（全置換・ライトプラン限定）
 */
export const useTagSetPatientTags = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagSetPatientTags>>, TError,{id: string;data: BodyType<SetPatientTagsDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagSetPatientTags>>,
        TError,
        {id: string;data: BodyType<SetPatientTagsDto>},
        TContext
      > => {

      const mutationOptions = getTagSetPatientTagsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary OHAT項目×スコア別ケアプロトコル一覧（共通デフォルト＋自組織カスタム、8項目×スコア1/2の16件）
 */
export const careProtocolFindAll = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/care-protocols`, method: 'GET', signal
    },
      options);
    }
  



export const getCareProtocolFindAllQueryKey = () => {
    return [
    `/care-protocols`
    ] as const;
    }

    
export const getCareProtocolFindAllQueryOptions = <TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCareProtocolFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof careProtocolFindAll>>> = ({ signal }) => careProtocolFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CareProtocolFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof careProtocolFindAll>>>
export type CareProtocolFindAllQueryError = ErrorType<HttpExceptionResponseDto>


export function useCareProtocolFindAll<TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof careProtocolFindAll>>,
          TError,
          Awaited<ReturnType<typeof careProtocolFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCareProtocolFindAll<TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof careProtocolFindAll>>,
          TError,
          Awaited<ReturnType<typeof careProtocolFindAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCareProtocolFindAll<TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary OHAT項目×スコア別ケアプロトコル一覧（共通デフォルト＋自組織カスタム、8項目×スコア1/2の16件）
 */

export function useCareProtocolFindAll<TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCareProtocolFindAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCareProtocolFindAllSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCareProtocolFindAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof careProtocolFindAll>>> = ({ signal }) => careProtocolFindAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CareProtocolFindAllSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof careProtocolFindAll>>>
export type CareProtocolFindAllSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function useCareProtocolFindAllSuspense<TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCareProtocolFindAllSuspense<TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCareProtocolFindAllSuspense<TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary OHAT項目×スコア別ケアプロトコル一覧（共通デフォルト＋自組織カスタム、8項目×スコア1/2の16件）
 */

export function useCareProtocolFindAllSuspense<TData = Awaited<ReturnType<typeof careProtocolFindAll>>, TError = ErrorType<HttpExceptionResponseDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof careProtocolFindAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCareProtocolFindAllSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary OHAT項目×スコアのケアプロトコルを設定（ライトプラン限定）。:id は項目番号 1..8、スコアはボディで指定（未指定は2）
 */
export const careProtocolSetItem = (
    id: string,
    updateCareProtocolDto: BodyType<UpdateCareProtocolDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<unknown>(
      {url: `/care-protocols/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCareProtocolDto
    },
      options);
    }
  


export const getCareProtocolSetItemMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careProtocolSetItem>>, TError,{id: string;data: BodyType<UpdateCareProtocolDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof careProtocolSetItem>>, TError,{id: string;data: BodyType<UpdateCareProtocolDto>}, TContext> => {

const mutationKey = ['careProtocolSetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careProtocolSetItem>>, {id: string;data: BodyType<UpdateCareProtocolDto>}> = (props) => {
          const {id,data} = props ?? {};

          return  careProtocolSetItem(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CareProtocolSetItemMutationResult = NonNullable<Awaited<ReturnType<typeof careProtocolSetItem>>>
    export type CareProtocolSetItemMutationBody = BodyType<UpdateCareProtocolDto>
    export type CareProtocolSetItemMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary OHAT項目×スコアのケアプロトコルを設定（ライトプラン限定）。:id は項目番号 1..8、スコアはボディで指定（未指定は2）
 */
export const useCareProtocolSetItem = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careProtocolSetItem>>, TError,{id: string;data: BodyType<UpdateCareProtocolDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careProtocolSetItem>>,
        TError,
        {id: string;data: BodyType<UpdateCareProtocolDto>},
        TContext
      > => {

      const mutationOptions = getCareProtocolSetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary OHAT項目×スコアのケアプロトコルを共通デフォルトに戻す（ライトプラン限定）。:id は項目番号 1..8、:score は 1|2
 */
export const careProtocolResetItem = (
    id: string,
    score: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<unknown>(
      {url: `/care-protocols/${id}/${score}`, method: 'DELETE'
    },
      options);
    }
  


export const getCareProtocolResetItemMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careProtocolResetItem>>, TError,{id: string;score: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof careProtocolResetItem>>, TError,{id: string;score: string}, TContext> => {

const mutationKey = ['careProtocolResetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof careProtocolResetItem>>, {id: string;score: string}> = (props) => {
          const {id,score} = props ?? {};

          return  careProtocolResetItem(id,score,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CareProtocolResetItemMutationResult = NonNullable<Awaited<ReturnType<typeof careProtocolResetItem>>>
    
    export type CareProtocolResetItemMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary OHAT項目×スコアのケアプロトコルを共通デフォルトに戻す（ライトプラン限定）。:id は項目番号 1..8、:score は 1|2
 */
export const useCareProtocolResetItem = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof careProtocolResetItem>>, TError,{id: string;score: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof careProtocolResetItem>>,
        TError,
        {id: string;score: string},
        TContext
      > => {

      const mutationOptions = getCareProtocolResetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 写真アップロード用の署名付きURLを発行（上限チェックのみ）
 */
export const photoPresign = (
    presignPhotoDto: BodyType<PresignPhotoDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PresignPhotoResponseDto>(
      {url: `/photos/presign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: presignPhotoDto, signal
    },
      options);
    }
  


export const getPhotoPresignMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof photoPresign>>, TError,{data: BodyType<PresignPhotoDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof photoPresign>>, TError,{data: BodyType<PresignPhotoDto>}, TContext> => {

const mutationKey = ['photoPresign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof photoPresign>>, {data: BodyType<PresignPhotoDto>}> = (props) => {
          const {data} = props ?? {};

          return  photoPresign(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PhotoPresignMutationResult = NonNullable<Awaited<ReturnType<typeof photoPresign>>>
    export type PhotoPresignMutationBody = BodyType<PresignPhotoDto>
    export type PhotoPresignMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary 写真アップロード用の署名付きURLを発行（上限チェックのみ）
 */
export const usePhotoPresign = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof photoPresign>>, TError,{data: BodyType<PresignPhotoDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof photoPresign>>,
        TError,
        {data: BodyType<PresignPhotoDto>},
        TContext
      > => {

      const mutationOptions = getPhotoPresignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 写真アップロードの確定（使用量カウント）
 */
export const photoConfirm = (
    confirmPhotoDto: BodyType<ConfirmPhotoDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/photos`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmPhotoDto, signal
    },
      options);
    }
  


export const getPhotoConfirmMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof photoConfirm>>, TError,{data: BodyType<ConfirmPhotoDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof photoConfirm>>, TError,{data: BodyType<ConfirmPhotoDto>}, TContext> => {

const mutationKey = ['photoConfirm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof photoConfirm>>, {data: BodyType<ConfirmPhotoDto>}> = (props) => {
          const {data} = props ?? {};

          return  photoConfirm(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PhotoConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof photoConfirm>>>
    export type PhotoConfirmMutationBody = BodyType<ConfirmPhotoDto>
    export type PhotoConfirmMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary 写真アップロードの確定（使用量カウント）
 */
export const usePhotoConfirm = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof photoConfirm>>, TError,{data: BodyType<ConfirmPhotoDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof photoConfirm>>,
        TError,
        {data: BodyType<ConfirmPhotoDto>},
        TContext
      > => {

      const mutationOptions = getPhotoConfirmMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary 評価に紐づく写真一覧（署名付きURL）
 */
export const photoListByScore = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PhotoResponseDto[]>(
      {url: `/ohat-scores/${id}/photos`, method: 'GET', signal
    },
      options);
    }
  



export const getPhotoListByScoreQueryKey = (id?: string,) => {
    return [
    `/ohat-scores/${id}/photos`
    ] as const;
    }

    
export const getPhotoListByScoreQueryOptions = <TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPhotoListByScoreQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof photoListByScore>>> = ({ signal }) => photoListByScore(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PhotoListByScoreQueryResult = NonNullable<Awaited<ReturnType<typeof photoListByScore>>>
export type PhotoListByScoreQueryError = ErrorType<HttpExceptionResponseDto>


export function usePhotoListByScore<TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof photoListByScore>>,
          TError,
          Awaited<ReturnType<typeof photoListByScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhotoListByScore<TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof photoListByScore>>,
          TError,
          Awaited<ReturnType<typeof photoListByScore>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhotoListByScore<TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 評価に紐づく写真一覧（署名付きURL）
 */

export function usePhotoListByScore<TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPhotoListByScoreQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPhotoListByScoreSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPhotoListByScoreQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof photoListByScore>>> = ({ signal }) => photoListByScore(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PhotoListByScoreSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof photoListByScore>>>
export type PhotoListByScoreSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function usePhotoListByScoreSuspense<TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhotoListByScoreSuspense<TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhotoListByScoreSuspense<TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 評価に紐づく写真一覧（署名付きURL）
 */

export function usePhotoListByScoreSuspense<TData = Awaited<ReturnType<typeof photoListByScore>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByScore>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPhotoListByScoreSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary 患者に紐づく写真一覧（時系列・署名付きURL）
 */
export const photoListByPatient = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PatientPhotoResponseDto[]>(
      {url: `/patients/${id}/photos`, method: 'GET', signal
    },
      options);
    }
  



export const getPhotoListByPatientQueryKey = (id?: string,) => {
    return [
    `/patients/${id}/photos`
    ] as const;
    }

    
export const getPhotoListByPatientQueryOptions = <TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPhotoListByPatientQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof photoListByPatient>>> = ({ signal }) => photoListByPatient(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PhotoListByPatientQueryResult = NonNullable<Awaited<ReturnType<typeof photoListByPatient>>>
export type PhotoListByPatientQueryError = ErrorType<HttpExceptionResponseDto>


export function usePhotoListByPatient<TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof photoListByPatient>>,
          TError,
          Awaited<ReturnType<typeof photoListByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhotoListByPatient<TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof photoListByPatient>>,
          TError,
          Awaited<ReturnType<typeof photoListByPatient>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhotoListByPatient<TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者に紐づく写真一覧（時系列・署名付きURL）
 */

export function usePhotoListByPatient<TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPhotoListByPatientQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPhotoListByPatientSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPhotoListByPatientQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof photoListByPatient>>> = ({ signal }) => photoListByPatient(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PhotoListByPatientSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof photoListByPatient>>>
export type PhotoListByPatientSuspenseQueryError = ErrorType<HttpExceptionResponseDto>


export function usePhotoListByPatientSuspense<TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhotoListByPatientSuspense<TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePhotoListByPatientSuspense<TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary 患者に紐づく写真一覧（時系列・署名付きURL）
 */

export function usePhotoListByPatientSuspense<TData = Awaited<ReturnType<typeof photoListByPatient>>, TError = ErrorType<HttpExceptionResponseDto>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof photoListByPatient>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPhotoListByPatientSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary 写真の削除
 */
export const photoRemove = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<unknown>(
      {url: `/photos/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getPhotoRemoveMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof photoRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof photoRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['photoRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof photoRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  photoRemove(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PhotoRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof photoRemove>>>
    
    export type PhotoRemoveMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary 写真の削除
 */
export const usePhotoRemove = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof photoRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof photoRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPhotoRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * システム管理者のメールアドレスへ 6 桁の確認コード（10 分有効）を送信する。再送信は 60 秒間隔。ステップアップ認証が無効な環境では 400（ADMIN_STEP_UP_DISABLED）。
 * @summary 管理画面の確認コードを送信
 */
export const adminStepUpRequest = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RequestAdminStepUpResponseDto>(
      {url: `/admin/step-up/request`, method: 'POST', signal
    },
      options);
    }
  


export const getAdminStepUpRequestMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStepUpRequest>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStepUpRequest>>, TError,void, TContext> => {

const mutationKey = ['adminStepUpRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStepUpRequest>>, void> = () => {
          

          return  adminStepUpRequest(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStepUpRequestMutationResult = NonNullable<Awaited<ReturnType<typeof adminStepUpRequest>>>
    
    export type AdminStepUpRequestMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary 管理画面の確認コードを送信
 */
export const useAdminStepUpRequest = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStepUpRequest>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStepUpRequest>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAdminStepUpRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * 確認コードが一致すれば 30 分間管理者モードを有効にする。不一致は 400（INVALID_CODE）、期限切れは 400（CODE_EXPIRED）、試行上限超過は 400（TOO_MANY_ATTEMPTS）。
 * @summary 管理画面の確認コードを検証
 */
export const adminStepUpVerify = (
    verifyAdminStepUpDto: BodyType<VerifyAdminStepUpDto>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<VerifyAdminStepUpResponseDto>(
      {url: `/admin/step-up/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyAdminStepUpDto, signal
    },
      options);
    }
  


export const getAdminStepUpVerifyMutationOptions = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStepUpVerify>>, TError,{data: BodyType<VerifyAdminStepUpDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminStepUpVerify>>, TError,{data: BodyType<VerifyAdminStepUpDto>}, TContext> => {

const mutationKey = ['adminStepUpVerify'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminStepUpVerify>>, {data: BodyType<VerifyAdminStepUpDto>}> = (props) => {
          const {data} = props ?? {};

          return  adminStepUpVerify(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminStepUpVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof adminStepUpVerify>>>
    export type AdminStepUpVerifyMutationBody = BodyType<VerifyAdminStepUpDto>
    export type AdminStepUpVerifyMutationError = ErrorType<HttpExceptionResponseDto>

    /**
 * @summary 管理画面の確認コードを検証
 */
export const useAdminStepUpVerify = <TError = ErrorType<HttpExceptionResponseDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminStepUpVerify>>, TError,{data: BodyType<VerifyAdminStepUpDto>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminStepUpVerify>>,
        TError,
        {data: BodyType<VerifyAdminStepUpDto>},
        TContext
      > => {

      const mutationOptions = getAdminStepUpVerifyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
